var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.noAvatar)?_c('span',{staticClass:"no-avatar",class:'bc' + _vm.user.peer_color_index,attrs:{"data-content":_vm.user.first_name[0].toUpperCase()}}):_c('img',{staticClass:"avatar",attrs:{"src":_vm.avatarUrl,"alt":"Avatar"}})}
var staticRenderFns = []

export { render, staticRenderFns }